import produce from 'immer';
import { TOGGLE_NIVEAU_FILTER_MENU } from './constants';

export const initialState = {
  niveauFilterMenuStatus: false,
};

/* eslint-disable default-case, no-param-reassign */
const niveauReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case TOGGLE_NIVEAU_FILTER_MENU:
        draft.niveauFilterMenuStatus = action.value;
        break;
      default:
        break;
    }
  });

export default niveauReducer;
